var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.61438 18H0.993462C0.444627 18 0 17.5551 0 17.0065V0.993454C0 0.444694 0.444697 0 0.993462 0H17.0066C17.5552 0 18 0.444694 18 0.993454V17.0065C18 17.5552 17.5552 18 17.0066 18H12.4197V11.0294H14.7594L15.1098 8.31284H12.4197V6.57849C12.4197 5.79198 12.6381 5.256 13.766 5.256L15.2045 5.25537V2.82566C14.9557 2.79255 14.1018 2.71859 13.1083 2.71859C11.0343 2.71859 9.61438 3.98457 9.61438 6.30945V8.31284H7.26867V11.0294H9.61438V18Z"}));
}

Facebook.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Facebook;

Facebook.default = Facebook;
